import { jsx as _jsx } from "react/jsx-runtime";
/**
 * LoginPage — embeds Clerk's <SignIn> component within the app's own layout.
 *
 * Using routing="path" means Clerk pushes real URLs for multi-step flows
 * (e.g. /login/factor-one for MFA challenges, /login/sso-callback for OAuth).
 * App.tsx registers `/login/*` as the route so React Router handles these
 * sub-paths without a 404.
 *
 * MFA:
 *   Clerk's <SignIn> automatically shows the MFA challenge step when the user
 *   has TOTP or SMS factors configured — no extra code required here.
 *
 * Appearance:
 *   The `appearance` prop maps Clerk's CSS variable tokens to our Tailwind
 *   palette. Clerk renders the component in an iframe-free embedded mode, so
 *   these tokens affect the actual DOM elements.
 */
import { SignIn } from '@clerk/clerk-react';
export function LoginPage() {
    return (_jsx(SignIn, { routing: "path", path: "/login", signUpUrl: "/register", afterSignInUrl: "/dashboard", appearance: {
            variables: {
                colorPrimary: '#7c2d12', // wine-800
                colorBackground: '#ffffff',
                borderRadius: '0.5rem',
                fontFamily: 'inherit',
            },
            elements: {
                // Blend the Clerk card into our own card styling
                card: 'shadow-none border-0',
                headerTitle: 'text-xl font-semibold text-gray-900',
                headerSubtitle: 'text-sm text-gray-500',
                formButtonPrimary: 'bg-wine-700 hover:bg-wine-800 text-white font-medium py-2.5 rounded-lg transition-colors',
                formFieldInput: 'border-gray-300 rounded-lg focus:ring-wine-600 focus:border-wine-600',
                footerActionLink: 'text-wine-700 hover:text-wine-800 font-medium',
                identityPreviewText: 'text-gray-700',
            },
        } }));
}
